import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import "../../../../src/content/running-from-god-sign-up/runningfromgod.scss";
import RFGpoConfirmation from "../../../../src/content/running-from-god-sign-up/customConfirmation.js";
import * as React from 'react';
export default {
  NewNamesForm,
  RFGpoConfirmation,
  React
};